/*
 * @Description:
 * @Date: 2021-10-19 16:40:25
 */

import apps from '../micros/index';

export const getCurrent = function() {
  const path = window.location.pathname;
  if (apps.findIndex(item => item.activeRule === path) >= 0) {
    return path;
  }
  return '';
};
/**
 * @description: 监听route更变
 */
export const listenRouterChange = function() {
  const _wr = function(type) {
    const orig = history[type];
    return function() {
      const rv = orig.apply(this, arguments);
      const e = new Event(type);
      e.arguments = arguments;
      window.dispatchEvent(e);
      return rv;
    };
  };
  // history.pushState = _wr('pushState');

  window.addEventListener('pushState', getCurrent);
  window.addEventListener('popstate', getCurrent);

  this.$once('hook:beforeDestroy', () => {
    window.removeEventListener('pushState', getCurrent);
    window.removeEventListener('popstate', getCurrent);
  });
};
